import { Button, Form, FormProps } from 'antd';
import React, { useEffect, useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import patterns from '../../config/patterns';
import { useFormState } from '../../hooks';
import authService from '../../services/auth.service';
import { notifyError, notifySuccess } from '../../utils/notification';
import { TAPasswordInput } from '../widgets';
import './antd.form.css';
import './user-management.css';

export const ResetPasswordForm: React.FC<FormProps & any> = props => {
	const [form] = Form.useForm();

	let [errors, setErrors] = useState();

	let resetToken = new URLSearchParams(useLocation().search).get('reset_token');
	let navigate = useNavigate();

	useEffect(() => {
		if (!resetToken) {
			notifyError('Invalid URL. token is missing');
			return;
		}
	}, []);

	const checkIfEqualFirstPassword = (rule, value) => {
		if (value) {
			if (value !== form.getFieldValue('password'))
				return Promise.reject('Two passwords that you entered are inconsistent!');
		}
		return Promise.resolve();
	};

	// const checkIfEqualConfirmationPassword = (rule, value) => {
	// 	if (value && value !== form.getFieldValue('passwordConfirmation'))
	// 		return Promise.reject('The new password has to be different from current password.');
	// 	if (value) {
	// 		return form.validateFields(['passwordConfirmation']);
	// 	}
	// 	return Promise.resolve();
	// };

	const onFinish = async values => {
		values['resetToken'] = resetToken;
		let { onError, onSubmit, onSuccess } = props;
		try {
			await authService.resetPassword(values);
			notifySuccess('Password changed successfully!');
			onSuccess && onSuccess();
			navigate('/signin');
		} catch (e: any) {
			setErrors(e.message);
			notifyError("Couldn't reset password!");
			onError && onError(e);
			return;
		}
	};

	return (
		<Form layout="vertical" className="ta-form" onFinish={onFinish} form={form}>
			<Form.Item
				label="New Password"
				name="password"
				rules={[
					{ required: true, message: 'Please enter password.' },
					{
						pattern: patterns.passwordPattern,
						message: 'Password must contain at least one alphabet and one number'
					}
					// { validator: checkIfEqualConfirmationPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item
				label="Confirm Password"
				name="passwordConfirmation"
				rules={[
					{ required: true, message: 'Please enter password confirmation.' },
					{ validator: checkIfEqualFirstPassword }
				]}
			>
				<TAPasswordInput />
			</Form.Item>

			<Form.Item>
				<Button htmlType="submit" className="ta-ant-btn" disabled={!resetToken}>
					Reset
				</Button>
			</Form.Item>
		</Form>
	);
};

export default ResetPasswordForm;
